import { Grid } from "@mui/material";
import { FunctionField, Labeled, useRecordContext } from "react-admin";
import { DebtStatusChoices } from "utils/choices";

const lookupName = (choices, id) => choices.find(c => c.id === id)?.name ?? "—";

const Payment = () => {
  const record = useRecordContext();
  const payment = record?.payment;
  if (!payment || (payment.fee == null && payment.providerId == null && payment.status == null))
    return <em>Няма данни за плащане</em>;

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={4}>
        <Labeled label="Такса">
          <FunctionField render={r => (r?.payment?.fee != null ? `${r.payment.fee} EUR` : "—")} />
        </Labeled>
      </Grid>
      <Grid item xs={12} md={4}>
        <Labeled label="Начин на плащане">
          <FunctionField render={r => r?.payment?.providerNameBg || "—"} />
        </Labeled>
      </Grid>
      <Grid item xs={12} md={4}>
        <Labeled label="Статус на плащане">
          <FunctionField
            render={r => (r?.payment?.status != null ? lookupName(DebtStatusChoices, r.payment.status) : "—")}
          />
        </Labeled>
      </Grid>
    </Grid>
  );
};

export default Payment;
